export default __webpack_public_path__ + "static/media/GA_Snappy-4.e8973eeb.wav";